import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../index';

export interface DevHandoffRow {
  id: number;
  uuid: string;
  token: string;
  project_name: string | null;
  project_uuid: string;
  member_name: string | null;
  member_email: string | null;
  status: 'sent' | 'failed' | 'skipped';
  created_at: string;
}

interface ListResponse {
  success: boolean;
  data: DevHandoffRow[];
  meta?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

interface ListParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const devHandoffsApi = createApi({
  reducerPath: 'devHandoffsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/admin/dev-handoffs',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['DevHandoffs'],
  endpoints: (builder) => ({
    listDevHandoffs: builder.query<ListResponse, ListParams | void>({
      query: (params = {}) => ({
        url: '/',
        params: {
          page: params?.page ?? 1,
          limit: params?.limit ?? 50,
          search: params?.search ?? '',
        },
      }),
      providesTags: ['DevHandoffs'],
    }),
  }),
});

export const { useListDevHandoffsQuery } = devHandoffsApi;
